
// ────────────────────────────────────────────────
// Login – OTP Step
// ────────────────────────────────────────────────
function LoginOtpForm({
  otp, setOtp,
  loading, onSubmit, onBack
}) {
  return (
    <form onSubmit={onSubmit}>
      <div style={{ marginBottom: '24px' }}>
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
          Enter 6-digit OTP
        </label>
        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="0 0 0 0 0 0"
          required
          maxLength={6}
          disabled={loading}
          style={{
            width: '100%',
            padding: '14px',
            fontSize: '22px',
            textAlign: 'center',
            letterSpacing: '8px',
            border: '1px solid #ccc',
            borderRadius: '8px',
          }}
        />
        <p style={{ fontSize: '14px', color: '#b4b3b3', marginTop: '8px' }}>
          Open your authenticator app (Google Authenticator, Authy, etc.)
        </p>
      </div>

      <button
        type="submit"
        disabled={loading}
        style={{
          width: '100%',
          padding: '14px',
          background: loading ? '#aaa' : '#4caf50',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          fontSize: '17px',
          cursor: loading ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? 'Verifying...' : 'Verify & Login'}
      </button>

      <button
        type="button"
        onClick={onBack}
        style={{
          width: '100%',
          marginTop: '16px',
          padding: '11px',
          background: 'transparent',
          color: '#1976d2',
          border: '1px solid #1976d2',
          borderRadius: '6px',
          cursor: 'pointer',
        }}
      >
        Back to Login
      </button>
    </form>
  );
}

export default LoginOtpForm;